import * as React from 'react';
import { Field, FormSection } from 'redux-form';
import { SimpleTextInputConfig } from '../SimpleTextInput/SimpleTextInput';
import { StateInputConfig } from '../StateInput/StateInput';
import { ZipCodeInputConfig } from '../ZipCodeInput/ZipCodeInput';
import './AddressInput.scss';

interface AddressInputDefinitionsMap {
  line1: FormInput;
  line2: FormInput;
  city: FormInput;
  state: FormInput;
  zip: FormInput;
}

const inputDefsMap: AddressInputDefinitionsMap = {
  line1: {
    ...SimpleTextInputConfig,
    label: 'Address line one',
    name: `lineText`,
    identifier: 'street address',
    placeholder: 'Street address, P.O. box',
  },
  line2: {
    ...SimpleTextInputConfig,
    label: 'Address line two',
    name: `additionalLineText`,
    identifier: 'address details',
    placeholder: 'Apt #, suite, unit, floor (optional)',
    optional: true,
  },
  city: {
    ...SimpleTextInputConfig,
    label: 'City',
    name: `cityName`,
    identifier: 'city',
  },
  state: {
    ...StateInputConfig,
    label: 'State',
    identifier: 'state',
    name: 'stateCode',
  },
  zip: {
    ...ZipCodeInputConfig,
    label: 'Zip code',
    identifier: 'zip code',
    name: 'zipCode',
  },
};

export const addressInputDefinitions = [
  inputDefsMap.line1,
  inputDefsMap.line2,
  inputDefsMap.city,
  inputDefsMap.state,
  inputDefsMap.zip,
];

/*
Note that this extends ReduxForm's FormSection, NOT a normal React.Component!

Implications are that it cannot be tested as a bare component, but the
benefit is that you can define fields as just having a simple name (e.g. "zip")
instead of needing to know its parent's name (e.g. `${input.name}.zip`).
*/

class AddressInput extends FormSection {
  render() {
    return (
      <div className="AddressInput">
        <div className="AddressInput-line AddressInput-line1">
          <Field {...inputDefsMap.line1} />
        </div>
        <div className="AddressInput-line AddressInput-line2">
          <Field {...inputDefsMap.line2} />
        </div>
        <div className="AddressInput-line AddressInput-city">
          <Field {...inputDefsMap.city} />
        </div>
        <div className="AddressInput-line">
          <div className="AddressInput-stateZipWrapper">
            <div className="AddressInput-stateWrapper">
              <Field {...inputDefsMap.state} />
            </div>
            <div className="AddressInput-zipWrapper">
              <Field {...inputDefsMap.zip} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const AddressInputConfig = {
  component: AddressInput,
};

export default AddressInput;
